module.exports = ".photoGallery{\r\n  padding-top: 10px;\r\n}\r\n"